import { IReducerAction } from "../../interfaces/IRedux";
import {
  ARTICLE_LOADING,
  ARTICLE_END_LOADING,
  ARTICLE_LOADING_OPERATION,
  ARTICLE_END_LOADING_OPERATION,
  ARTICLE_GET_DATA,
  ARTICLE_GET_ITEM,
  ARTICLE_CLEAR,
  ARTICLE_UPDATE_STATUS,
  ARTICLE_DELETE_ELEMENT,
  ARTICLE_ADD_SINGLE,
  ARTICLE_UPDATE_SINGLE,
} from "../types";

const initialState = {
  loading: false,
  loadingOperation: false,
  elements: [],
  pagination: {},
  item: null,
};

export default function reducer(state = initialState, action: IReducerAction) {
  const payload = action.payload || {};

  switch (action.type) {
    case ARTICLE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case ARTICLE_END_LOADING:
      return {
        ...state,
        loading: false,
      };

    case ARTICLE_LOADING_OPERATION:
      return {
        ...state,
        loadingOperation: true,
      };

    case ARTICLE_END_LOADING_OPERATION:
      return {
        ...state,
        loadingOperation: false,
      };

    case ARTICLE_GET_DATA:
      // @ts-ignore
      const rows = Array.isArray(payload) ? payload : payload.rows;
      // @ts-ignore
      const pagination = payload.pagination || {};
      return {
        ...state,
        loading: false,
        elements: rows || [],
        pagination,
      };

    case ARTICLE_GET_ITEM:
      return {
        ...state,
        loading: false,
        loadingOperation: false,
        item: payload,
      };

    case ARTICLE_ADD_SINGLE:
      if (payload && Object.keys(payload).length > 0) {
        // @ts-ignore
        const itemIndex = state.elements.findIndex((e) => e.id === payload.id);
        if (itemIndex < 0) {
          state.elements.splice(0, 0, payload);
        }
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case ARTICLE_UPDATE_SINGLE:
      if (payload && Object.keys(payload).length > 0) {
        // @ts-ignore
        const itemIndex = state.elements.findIndex((e) => e.id === payload.id);
        state.elements[itemIndex] = payload;
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case ARTICLE_UPDATE_STATUS:
      if (payload && Object.keys(payload).length > 0) {
        // @ts-ignore
        const itemId = payload.id;
        // @ts-ignore
        const articleIndex = state.elements.findIndex((e) => e.id === itemId);
        if (articleIndex >= 0) {
          // @ts-ignore
          state.elements[articleIndex].status = payload.status;
        }
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case ARTICLE_DELETE_ELEMENT:
      if (payload && Object.keys(payload).length > 0) {
        // @ts-ignore
        const itemId = payload.id;
        // @ts-ignore
        const articleIndex = state.elements.findIndex((e) => e.id === itemId);
        if (articleIndex >= 0) {
          state.elements.splice(articleIndex, 1);
        }
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case ARTICLE_CLEAR:
      return initialState;
    default:
      return state;
  }
}
